import React, { useEffect, useState, useCallback } from "react";

import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";

import { API } from "../api";

import { toasts } from "../components/AppToast";

import {
  FiTrash2,
  FiEdit,
  FiEye,
  FiClipboard,
  FiSave,
  FiPlus,
  FiSearch,
  FiCalendar,
} from "react-icons/fi";
import {FaCar } from "react-icons/fa";
import { SiToyota } from "react-icons/si";


export default function Stopsale() {
  const navigate = useNavigate();

  // FORMAT DATE

  const formatDate = (date) => {
    if (!date) return "";

    const d = new Date(date);

    return (
      d.getFullYear() +
      "-" +
      String(d.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(d.getDate()).padStart(2, "0")
    );
  };

  // STATES

  const [data, setData] = useState([]);

  const [groups, setGroups] = useState([]);

  const [cars, setCars] = useState([]);

  const [page, setPage] = useState(1);

  const [totalPages, setTotalPages] = useState(1);

  const [total, setTotal] = useState(0);

  const [search, setSearch] = useState("");

  const [filterGroup, setFilterGroup] = useState(0);

  const [loading, setLoading] = useState(false);

  const [user, setUser] = useState(null);

  const [stopSale, setStopsale] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);

  // DELETE MODAL STATES

  const [delModal, setDelModal] = useState(null);

  const [delSaving, setDelSaving] = useState(false);

  // FORM

  const [form, setForm] = useState({
    cat_id: "",
    carmodel_id: "",
    from_date: "",
    to_date: "",
  });

  const [editId, setEditId] = useState(null);

  // AUTH

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/login");

      return;
    }

    setUser(JSON.parse(localStorage.getItem("user") || "null"));
  }, [navigate]);

  // FETCH STOP SALE DATA

  const fetchData = useCallback(
    (pg = page, q = search, categoryId = filterGroup) => {
      setLoading(true);

      API.get("/stopsale", {
        params: {
          page: pg,
          limit: 10,
          search: q,
          cat_id: categoryId,
        },
      })

        .then((res) => {
          setData(res.data.data || []);

          setTotalPages(res.data.totalPages || 1);

          setTotal(res.data.total || 0);
        })

        .catch(() => {
          toasts.error("Failed to load stop sale data");
        })

        .finally(() => {
          setLoading(false);
        });
    },
    [page, search, filterGroup]
  );

  // LOAD DATA

  useEffect(() => {
    fetchData(page, search, filterGroup);
  }, [page, search, filterGroup, fetchData]);

  // LOAD GROUPS + CARS

  useEffect(() => {
    API.get("/cargroup", {
      params: {
        page: 1,
        limit: 100,
      },
    })
      .then((r) => {
        setGroups(r.data.data || []);
      })
      .catch(() => {
        toasts.error("Failed to load car groups");
      });

    API.get("/cars", {
      params: {
        page: 1,
        limit: 100,
      },
    })
      .then((r) => {
        setCars(r.data.data || []);
      })
      .catch(() => {
        toasts.error("Failed to load cars");
      });
  }, []);

  // OPEN ADD MODAL

  const openAddModal = () => {
    setForm({
      cat_id: "",
      carmodel_id: "",
      from_date: "",
      to_date: "",
    });

    setEditId(null);

    setModalOpen(true);
  };

  // CLOSE FORM MODAL

  const closeFormModal = () => {
    setModalOpen(false);
  };

  // SUBMIT

  const handleSubmit = async () => {
    if (!form.cat_id) {
      toasts.warning("Please select a car group");

      return;
    }

    if (!form.carmodel_id) {
      toasts.warning("Please select a car");

      return;
    }

    if (!form.from_date) {
      toasts.warning("Please select from date");

      return;
    }

    if (!form.to_date) {
      toasts.warning("Please select to date");

      return;
    }

    if (new Date(form.from_date) > new Date(form.to_date)) {
      toasts.warning("To date must be greater than or equal to from date");

      return;
    }

    try {
      if (editId) {
        await API.put(`/stopsale/${editId}`, {
          ...form,
          user_id: user?.user_id,
        });

        toasts.success("Stop sale updated successfully");
      } else {
        await API.post("/stopsale", {
          ...form,
          user_id: user?.user_id,
        });

        toasts.success("Stop sale added successfully");
      }

      setModalOpen(false);

      fetchData(page, search, filterGroup);
    } catch (err) {
      toasts.error(err.response?.data?.error || "Operation failed");
    }
  };

  // OPEN DELETE MODAL

  const openDeleteModal = (row) => {
    setDelModal(row);
  };

  // CLOSE DELETE MODAL

  const closeDeleteModal = () => {
    if (delSaving) return;

    setDelModal(null);
  };

  // CONFIRM DELETE

  const confirmDelete = async () => {
    if (!delModal?.nonavailprd_id) {
      return;
    }

    setDelSaving(true);

    try {
      await API.delete(`/stopsale/${delModal.nonavailprd_id}`);

      toasts.success("Stop sale deleted successfully");

      setDelModal(null);

      // If deleting last item on current page
      if (data.length === 1 && page > 1) {
        setPage((p) => Math.max(1, p - 1));
      } else {
        fetchData(page, search, filterGroup);
      }
    } catch (err) {
      toasts.error(err.response?.data?.error || "Delete failed");
    } finally {
      setDelSaving(false);
    }
  };

  // RENDER

  return (
    <Layout activePage="Stop Sale">
      <main className="dashboard-main">
        {/* TABLE CARD*/}

        <div className="table-card">
          {/*   HEADER
          ================================================= */}

          <div className="table-card-head">
            <h3 className="table-card-title d-flex align-items-center">
              <FiClipboard size={26} className="me-2" />
              Manage Stop Sale
              <span className="rec-count ms-1">{total} records</span>
            </h3>

            {/* SEARCH */}

            <div className="search-wrapper">
              <span className="search-icon">
                <FiSearch />
              </span>

              <input
                type="text"
                placeholder="Search car..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);

                  setPage(1);
                }}
                className="search-input"
              />

              {search && (
                <button
                  type="button"
                  className="season-clear-btn"
                  onClick={() => {
                    setSearch("");

                    setPage(1);
                  }}
                >
                  ✕
                </button>
              )}
            </div>

            {/* GROUP */}

            <select
              value={filterGroup}
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);

                setFilterGroup(value);

                setPage(1);

                fetchData(1, search, value);
              }}
              className="season-input"
            >
              <option value={0}>— All Groups —</option>

              {groups.map((g) => (
                <option key={g.cat_id} value={g.cat_id}>
                  {g.cat_name}
                </option>
              ))}
            </select>

            {/* ADD */}

            <button
              type="button"
              className="um-btn-primary"
              onClick={openAddModal}
            >
              <span className="um-add-icon">＋</span>
              Add Stop Sale
            </button>
          </div>

          {/*   TABLE
          ================================================= */}

          <div className="table-responsive">
            <table className="um-table">
              <thead>
                <tr className="um-table-head">
                  <th className="um-th text-center">#</th>

                  <th className="um-th text-center">Group</th>

                  <th className="um-th text-center">Car</th>

                  <th className="um-th text-center">From</th>

                  <th className="um-th text-center">To</th>

                  <th className="um-th text-center">Action</th>
                </tr>
              </thead>

              <tbody>
                {/* LOADING */}

                {loading ? (
                  Array.from({
                    length: 5,
                  }).map((_, i) => (
                    <tr key={i}>
                      {Array.from({
                        length: 6,
                      }).map((_, j) => (
                        <td key={j} className="um-td text-center">
                          <div className="skeleton" />
                        </td>
                      ))}
                    </tr>
                  ))
                ) : data.length === 0 ? (
                  /* EMPTY */

                  <tr>
                    <td
                      colSpan={6}
                      className="empty-table-cell text-center py-5"
                    >
                      <div className="empty-icon"><FaCar/> </div>

                      <div className="empty-title">No cars found</div>

                      <div className="empty-sub">
                        No stop-sale records found
                      </div>
                    </td>
                  </tr>
                ) : (
                  /* RECORDS */

                  data.map((row, i) => (
                    <tr
                      key={row.nonavailprd_id}
                      className={`um-row ${
                        i % 2 === 0 ? "even-row" : "odd-row"
                      }`}
                    >
                      {/* NUMBER */}

                      <td className="um-td text-center">
                        {(page - 1) * 10 + i + 1}
                      </td>

                      {/* GROUP */}

                      <td className="um-td text-center">
                        <span className="car-group-badge">
                          {row.cat_name || "—"}
                        </span>
                      </td>

                      {/* CAR */}

                      <td className="um-td text-center">
                        <span className="car-name-badge">
                          {row.carmodel_name || "—"}
                        </span>
                      </td>

                      {/* FROM */}

                      <td className="um-td text-center">
                        <span className="date-badge">
                          {formatDate(row.nonavailprd_frmdt)}
                        </span>
                      </td>

                      {/* TO */}

                      <td className="um-td text-center">
                        <span className="date-badge">
                          {formatDate(row.nonavailprd_todt)}
                        </span>
                      </td>

                      {/* ACTION */}

                      <td className="um-td text-center">
                        <div className="action-buttons">
                          {/* VIEW */}

                          <button
                            type="button"
                            className="action-btn action-view"
                            title="View"
                            onClick={() => setStopsale(row)}
                          >
                            <FiEye size={15} />
                          </button>

                          {/* EDIT */}

                          <button
                            type="button"
                            className="action-btn action-edit"
                            title="Edit"
                            onClick={() => {
                              setForm({
                                cat_id: String(row.cartype_id || ""),

                                carmodel_id: String(row.carmodel_id || ""),

                                from_date: formatDate(row.nonavailprd_frmdt),

                                to_date: formatDate(row.nonavailprd_todt),
                              });

                              setEditId(row.nonavailprd_id);

                              setModalOpen(true);
                            }}
                          >
                            <FiEdit size={15} />
                          </button>

                          {/* DELETE */}

                          <button
                            type="button"
                            className="action-btn action-delete delete-enabled"
                            title="Delete"
                            onClick={() => openDeleteModal(row)}
                          >
                            <FiTrash2 size={15} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {/*  PAGINATION*/}

            <div className="pagination">
              <span className="pagin-info">
                {total > 0
                  ? `Showing ${(page - 1) * 10 + 1}–${Math.min(
                      page * 10,
                      total
                    )} of ${total}`
                  : ""}
              </span>

              <div className="d-flex align-items-center gap-2">
                <button
                  type="button"
                  className="pg-btn"
                  disabled={page === 1 || loading}
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                >
                  ← Prev
                </button>

                <span className="pagin-info">
                  Page {page} / {totalPages || 1}
                </span>

                <button
                  type="button"
                  className="pg-btn"
                  disabled={page >= totalPages || totalPages === 0 || loading}
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                >
                  Next →
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ADD / EDIT MODAL*/}

        {modalOpen && (
          <div className="um-overlay" onClick={closeFormModal}>
            <div
              className="um-modal rent-duration-modal"
              onClick={(e) => e.stopPropagation()}
            >
              {/* HEADER */}

              <div className="um-modal-head">
                <div className="d-flex align-items-center gap-2">
                  <div className="form-card-icon">
                    {editId ? <FiEdit size={24} /> : <FiPlus size={24} />}
                  </div>

                  <div>
                    <h2 className="um-modal-title mb-0">
                      {editId ? "Edit Stop Sale" : "Add Stop Sale"}
                    </h2>

                    <p className="form-card-sub mb-0">
                      {editId
                        ? "Modify the selected stop sale details"
                        : "Add a new stop sale period for a car"}
                    </p>
                  </div>
                </div>

                <button
                  type="button"
                  className="um-x-btn"
                  onClick={closeFormModal}
                >
                  ✕
                </button>
              </div>

              {/* BODY */}

              <div className="um-modal-scroll">
                <input type="hidden" value={user?.user_id || ""} readOnly />

                <div className="row g-3">
                  {/* CAR GROUP */}

                  <div className="field-box col-md-6">
                    <label className="field-label">CAR GROUP *</label>

                    <select
                      className="rd-input"
                      value={String(form.cat_id || "")}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          cat_id: e.target.value,
                          carmodel_id: "",
                        })
                      }
                    >
                      <option value="">Select Group</option>

                      {groups.map((g) => (
                        <option key={g.cat_id} value={String(g.cat_id)}>
                          {g.cat_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* CAR */}

                  <div className="field-box col-md-6">
                    <label className="field-label">CAR *</label>

                    <select
                      className="rd-input"
                      value={String(form.carmodel_id || "")}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          carmodel_id: e.target.value,
                        })
                      }
                      disabled={!form.cat_id}
                    >
                      <option value="">
                        {form.cat_id ? "Select Car" : "Select Group First"}
                      </option>

                      {cars
                        .filter(
                          (car) => String(car.cat_id) === String(form.cat_id)
                        )
                        .map((car) => (
                          <option
                            key={car.carmodel_id}
                            value={String(car.carmodel_id)}
                          >
                            {car.carmodel_name}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/* FROM DATE */}

                  <div className="field-box col-md-6">
                    <label className="field-label">FROM DATE *</label>

                    <input
                      className="rd-input"
                      type="date"
                      value={form.from_date}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          from_date: e.target.value,
                        })
                      }
                    />

                    <div className="field-hint">
                      Start date of stop sale period
                    </div>
                  </div>

                  {/* TO DATE */}

                  <div className="field-box col-md-6">
                    <label className="field-label">TO DATE *</label>

                    <input
                      className="rd-input"
                      type="date"
                      value={form.to_date}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          to_date: e.target.value,
                        })
                      }
                    />

                    <div className="field-hint">
                      End date of stop sale period
                    </div>
                  </div>
                </div>
              </div>

              {/* FOOTER */}

              <div className="um-modal-foot">
                <button
                  type="button"
                  className="rd-btn-secondary"
                  onClick={closeFormModal}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="um-btn-primary"
                  onClick={handleSubmit}
                >
                  {editId ? (
                    <>
                      <FiSave />
                      Update Stop Sale
                    </>
                  ) : (
                    <>
                      <FiPlus />
                      Save Stop Sale
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* VIEW MODAL*/}

        {stopSale && (
          <div className="um-overlay" onClick={() => setStopsale(null)}>
            <div
              className="um-modal um-view-modal"
              onClick={(e) => e.stopPropagation()}
            >
              {/* HEADER */}

              <div className="um-modal-head">
                <h2 className="um-modal-title"><FaCar/>  {stopSale.carmodel_name}</h2>

                <button
                  type="button"
                  className="um-x-btn"
                  onClick={() => setStopsale(null)}
                >
                  ✕
                </button>
              </div>

              {/* BODY */}

              <div className="um-modal-scroll">
                <div className="row g-3">
                  {[
                    {
                      label: "Group",
                      value: stopSale.cat_name,
                      icon:  <FaCar/>,
                    },

                    {
                      label: "Brand",
                      value: stopSale.brand_name,
                      icon: <SiToyota/>,
                    },

                    {
                      label: "From Date",
                      value: formatDate(stopSale.nonavailprd_frmdt),
                      icon: <FiCalendar/>,
                    },

                    {
                      label: "To Date",
                      value: formatDate(stopSale.nonavailprd_todt),
                      icon: <FiCalendar/>,
                    },
                  ].map((r) => (
                    <div
                      key={r.label}
                      className="col-xl-6 col-lg-6 col-md-6 col-12"
                    >
                      <div className="profile-row">
                        <div className="profile-row-icon">{r.icon}</div>

                        <div>
                          <div className="profile-row-label">{r.label}</div>

                          <div className="profile-row-value">
                            {r.value || "—"}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* FOOTER */}

              <div className="um-modal-foot">
                <button
                  type="button"
                  className="um-btn-secondary"
                  onClick={() => setStopsale(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {/* DELETE MODAL*/}

        {delModal && (
          <div className="um-overlay" onClick={closeDeleteModal}>
            <div
              className="um-modal um-delete-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="delete-content">
                {/* ICON */}

                <div className="delete-icon">
                  <FiTrash2 size={32} />
                </div>

                {/* TITLE */}

                <h2 className="delete-title">Delete Stop Sale?</h2>

                {/* DESCRIPTION */}

                <p className="delete-description">
                  Are you sure you want to delete{" "}
                  <span className="badge badge-success">
                    "{delModal.carmodel_name || "this record"}"
                  </span>
                  ?
                  <br />
                  This will permanently remove this stop-sale record.
                  <br />
                  <strong>This action cannot be undone.</strong>
                </p>

                {/* ACTIONS */}

                <div className="delete-actions">
                  {/* CANCEL */}

                  <button
                    type="button"
                    className="um-btn-secondary"
                    onClick={closeDeleteModal}
                    disabled={delSaving}
                  >
                    Cancel
                  </button>

                  {/* DELETE */}

                  <button
                    type="button"
                    disabled={delSaving}
                    className="delete-confirm-btn"
                    onClick={confirmDelete}
                  >
                    {delSaving ? (
                      <span className="spinner" />
                    ) : (
                      <>
                        <FiTrash2 />
                        Delete Permanently
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

       
      </main>
    </Layout>
  );
}
